import React, { useState } from "react";
import { Button, Input, Space } from "antd";
import { WbFactValue } from "../../workbench/types/WbTypes";

const WorkbenchFactCorrection: React.FC<{
    field: string;
    label: string;
    disabled: boolean;
    onSave: (value?: string, details?: WbFactValue) => Promise<void>;
}> = ({ field, label, disabled, onSave }) => {
    const [value, setValue] = useState("");
    const [secondary, setSecondary] = useState("");
    const period = field === "insuredPeriod" || field === "contractPeriod";
    const scopedReference = [
        "brokerReference",
        "cedentReference",
        "cedentContractReference",
    ].includes(field);
    const amount = field === "claimAmount";
    const save = () => {
        if (period)
            return onSave(undefined, {
                periodFrom: value || null,
                periodTo: secondary || null,
            });
        if (amount)
            return onSave(undefined, {
                amount: value ? Number(value) : null,
                currency: secondary || null,
            });
        if (field === "mainClass")
            return onSave(value, {
                values: value
                    .split(",")
                    .map((item) => item.trim())
                    .filter(Boolean),
            });
        if (scopedReference)
            return onSave(value.trim(), { partyScope: secondary.trim() });
        return onSave(value);
    };
    return (
        <Space wrap style={{ marginTop: 8 }}>
            <Input
                aria-label={`Correct ${label}`}
                disabled={disabled}
                value={value}
                type={
                    period || field === "lossDate"
                        ? "date"
                        : amount || field === "uwYear"
                          ? "number"
                          : "text"
                }
                step={amount ? "any" : undefined}
                maxLength={2000}
                placeholder={
                    period
                        ? "Start date"
                        : amount
                          ? "Amount"
                          : field === "mainClass"
                            ? "Classes, separated by commas"
                            : "Enter corrected value"
                }
                onChange={(event) => setValue(event.target.value)}
            />
            {(period || amount || scopedReference) && (
                <Input
                    aria-label={
                        period
                            ? `${label} end date`
                            : scopedReference
                              ? `${label} party scope`
                              : `${label} currency`
                    }
                    type={period ? "date" : "text"}
                    value={secondary}
                    disabled={disabled}
                    maxLength={amount ? 20 : undefined}
                    placeholder={
                        period
                            ? "End date"
                            : scopedReference
                              ? "Party ID or name"
                              : "Currency"
                    }
                    onChange={(event) => setSecondary(event.target.value)}
                />
            )}
            <Button
                aria-label={`Save ${label} correction`}
                disabled={
                    disabled ||
                    (scopedReference && (!secondary.trim() || !value.trim())) ||
                    !(
                        value.trim() ||
                        ((period || amount || scopedReference) &&
                            secondary.trim())
                    )
                }
                onClick={save}
            >
                Save correction
            </Button>
        </Space>
    );
};

export default WorkbenchFactCorrection;
